<template>
    <div
        data-theme="patsnapRD"
        class="fixed top-0 left-0 z-[99999] flex h-full w-full items-center justify-center"
    >
        <div
            v-if="visible"
            class="message-box-overlay absolute top-0 left-0 h-full w-full bg-black bg-opacity-50"
        ></div>
        <div v-if="visible" class="z-10 flex flex-col gap-4 rounded bg-white p-5">
            <h2 class="text-black">{{ t('us.confirm_password.title') }}</h2>
            <p class="text-sm text-grey-450">{{ t('us.confirm_password.message', { email: email }) }}</p>
            <input
                v-model="inputValue"
                :placeholder="t('us.confirm_password.inputPlaceholder')"
                type="password"
                class="th-input h-8 min-w-[400px] rounded shadow-none focus-within:border-eureka-500 hover:border-eureka-500"
            />
            <p v-if="inputError" class="text-sm text-red-500">
                {{ t('us.confirm_password.inputErrorMessage') }}
            </p>
            <div class="flex justify-end gap-2">
                <button
                    type="button"
                    class="th-btn th-btn-secondary"
                    @click="cancel"
                >
                    {{ t('us.confirm_password.cancelButtonText') }}
                </button>
                <button
                    type="button"
                    class="th-btn"
                    :disabled="inputError"
                    @click="confirm"
                >
                    {{ t('us.confirm_password.confirmButtonText') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import { cn, tw, en, jp } from '../../../locales';
import { useI18n } from 'vue-i18n';
import { isValidPassword } from '../../utils/validate';

const { t } = useI18n({
    messages: {
        cn, en, jp, tw,
    },
})

const props = defineProps({
    email: {
        type: String,
        default: '',
    },
    callback: {
        type: Function,
        default: undefined,
    },
    cancelCallback: {
        type: Function,
        default: undefined,
    },
});

const visible = ref(true);
const inputValue = ref('');

const inputError = computed(() => {
    return !inputValue.value || !isValidPassword(inputValue.value);
});

function close() {
    visible.value = false;
}

function confirm() {
    if (inputError.value) return;
    if (props.callback) {
        props.callback(inputValue.value);
    }
    close();
}

function cancel() {
    if (props.cancelCallback) {
        props.cancelCallback();
    }
    close();
}
</script>
